var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjBooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 269,
    viewBox: "0 0 192 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57129 18.8096H187.71C189.612 18.8096 191.147 20.3455 191.147 22.2472V264.562C191.147 266.464 189.612 268 187.71 268H5.57129C3.04794 268 1 265.952 1 263.429V23.3992C1 20.8758 3.04794 18.8279 5.57129 18.8279V18.8096Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 188.332C169.133 188.332 169.023 188.423 169.023 188.533C169.023 188.642 169.115 188.734 169.243 188.734H173.65C173.759 188.734 173.869 188.642 173.869 188.533C173.869 188.423 173.778 188.332 173.65 188.332H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 188.551C174.911 188.441 175.002 188.35 175.13 188.35H179.537C179.647 188.35 179.756 188.441 179.756 188.551C179.756 188.661 179.665 188.752 179.537 188.752H175.13C175.02 188.752 174.911 188.661 174.911 188.551Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 190.892C169.133 190.892 169.023 190.983 169.023 191.093C169.023 191.203 169.115 191.294 169.243 191.294H173.65C173.759 191.294 173.869 191.203 173.869 191.093C173.869 190.983 173.778 190.892 173.65 190.892H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 191.111C174.911 191.002 175.002 190.91 175.13 190.91H179.537C179.647 190.91 179.756 191.002 179.756 191.111C179.756 191.221 179.665 191.312 179.537 191.312H175.13C175.02 191.312 174.911 191.221 174.911 191.111Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 193.47C169.133 193.47 169.023 193.561 169.023 193.671C169.023 193.781 169.115 193.872 169.243 193.872H173.65C173.759 193.872 173.869 193.781 173.869 193.671C173.869 193.561 173.778 193.47 173.65 193.47H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 193.671C174.911 193.561 175.002 193.47 175.13 193.47H179.537C179.647 193.47 179.756 193.561 179.756 193.671C179.756 193.781 179.665 193.872 179.537 193.872H175.13C175.02 193.872 174.911 193.781 174.911 193.671Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 196.03C169.133 196.03 169.023 196.121 169.023 196.231C169.023 196.341 169.115 196.432 169.243 196.432H173.65C173.759 196.432 173.869 196.341 173.869 196.231C173.869 196.121 173.778 196.03 173.65 196.03H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 196.231C174.911 196.121 175.002 196.03 175.13 196.03H179.537C179.647 196.03 179.756 196.121 179.756 196.231C179.756 196.341 179.665 196.432 179.537 196.432H175.13C175.02 196.432 174.911 196.341 174.911 196.231Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 198.59C169.133 198.59 169.023 198.681 169.023 198.791C169.023 198.9 169.115 198.992 169.243 198.992H173.65C173.759 198.992 173.869 198.9 173.869 198.791C173.869 198.681 173.778 198.59 173.65 198.59H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 198.791C174.911 198.681 175.002 198.59 175.13 198.59H179.537C179.647 198.59 179.756 198.681 179.756 198.791C179.756 198.9 179.665 198.992 179.537 198.992H175.13C175.02 198.992 174.911 198.9 174.911 198.791Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 201.15C169.133 201.15 169.023 201.241 169.023 201.351C169.023 201.461 169.115 201.552 169.243 201.552H170.34C170.45 201.552 170.559 201.461 170.559 201.351C170.559 201.241 170.468 201.15 170.34 201.15H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.22 201.351C178.22 201.241 178.311 201.15 178.439 201.15H179.171C179.28 201.15 179.39 201.241 179.39 201.351C179.39 201.461 179.299 201.552 179.171 201.552H178.439C178.329 201.552 178.22 201.461 178.22 201.351Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 203.709C169.133 203.709 169.023 203.801 169.023 203.911C169.023 204.02 169.115 204.112 169.243 204.112H173.65C173.759 204.112 173.869 204.02 173.869 203.911C173.869 203.801 173.778 203.709 173.65 203.709H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 203.929C174.911 203.819 175.002 203.728 175.13 203.728H179.537C179.647 203.728 179.756 203.819 179.756 203.929C179.756 204.039 179.665 204.13 179.537 204.13H175.13C175.02 204.13 174.911 204.039 174.911 203.929Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 206.27C169.133 206.27 169.023 206.361 169.023 206.471C169.023 206.58 169.115 206.672 169.243 206.672H173.65C173.759 206.672 173.869 206.58 173.869 206.471C173.869 206.361 173.778 206.27 173.65 206.27H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 206.489C174.911 206.379 175.002 206.288 175.13 206.288H179.537C179.647 206.288 179.756 206.379 179.756 206.489C179.756 206.599 179.665 206.69 179.537 206.69H175.13C175.02 206.69 174.911 206.599 174.911 206.489Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 208.83C169.133 208.83 169.023 208.921 169.023 209.031C169.023 209.14 169.115 209.232 169.243 209.232H173.65C173.759 209.232 173.869 209.14 173.869 209.031C173.869 208.921 173.778 208.83 173.65 208.83H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 209.049C174.911 208.939 175.002 208.848 175.13 208.848H179.537C179.647 208.848 179.756 208.939 179.756 209.049C179.756 209.159 179.665 209.25 179.537 209.25H175.13C175.02 209.25 174.911 209.159 174.911 209.049Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 211.407C169.133 211.407 169.023 211.499 169.023 211.609C169.023 211.718 169.115 211.81 169.243 211.81H173.65C173.759 211.81 173.869 211.718 173.869 211.609C173.869 211.499 173.778 211.407 173.65 211.407H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 211.609C174.911 211.499 175.002 211.407 175.13 211.407H179.537C179.647 211.407 179.756 211.499 179.756 211.609C179.756 211.718 179.665 211.81 179.537 211.81H175.13C175.02 211.81 174.911 211.718 174.911 211.609Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.023 216.874C169.023 216.765 169.225 216.673 169.499 216.673H179.281C179.537 216.673 179.757 216.765 179.757 216.874C179.757 216.984 179.556 217.075 179.281 217.075H169.499C169.243 217.075 169.023 216.984 169.023 216.874Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 221.976C169.133 221.976 169.023 222.068 169.023 222.177C169.023 222.287 169.115 222.379 169.243 222.379H173.65C173.759 222.379 173.869 222.287 173.869 222.177C173.869 222.068 173.778 221.976 173.65 221.976H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 222.196C174.911 222.086 175.002 221.995 175.13 221.995H179.537C179.647 221.995 179.756 222.086 179.756 222.196C179.756 222.306 179.665 222.397 179.537 222.397H175.13C175.02 222.397 174.911 222.306 174.911 222.196Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 224.554C169.133 224.554 169.023 224.646 169.023 224.756C169.023 224.865 169.115 224.957 169.243 224.957H173.65C173.759 224.957 173.869 224.865 173.869 224.756C173.869 224.646 173.778 224.554 173.65 224.554H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 224.756C174.911 224.646 175.002 224.554 175.13 224.554H179.537C179.647 224.554 179.756 224.646 179.756 224.756C179.756 224.865 179.665 224.957 179.537 224.957H175.13C175.02 224.957 174.911 224.865 174.911 224.756Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 227.115C169.133 227.115 169.023 227.206 169.023 227.316C169.023 227.426 169.115 227.517 169.243 227.517H173.65C173.759 227.517 173.869 227.426 173.869 227.316C173.869 227.206 173.778 227.115 173.65 227.115H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 227.316C174.911 227.206 175.002 227.115 175.13 227.115H179.537C179.647 227.115 179.756 227.206 179.756 227.316C179.756 227.426 179.665 227.517 179.537 227.517H175.13C175.02 227.517 174.911 227.426 174.911 227.316Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 229.675C169.133 229.675 169.023 229.766 169.023 229.876C169.023 229.986 169.115 230.077 169.243 230.077H173.65C173.759 230.077 173.869 229.986 173.869 229.876C173.869 229.766 173.778 229.675 173.65 229.675H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 229.876C174.911 229.766 175.002 229.675 175.13 229.675H179.537C179.647 229.675 179.756 229.766 179.756 229.876C179.756 229.986 179.665 230.077 179.537 230.077H175.13C175.02 230.077 174.911 229.986 174.911 229.876Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 232.234C169.133 232.234 169.023 232.326 169.023 232.435C169.023 232.545 169.115 232.636 169.243 232.636H173.65C173.759 232.636 173.869 232.545 173.869 232.435C173.869 232.326 173.778 232.234 173.65 232.234H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 232.435C174.911 232.326 175.002 232.234 175.13 232.234H179.537C179.647 232.234 179.756 232.326 179.756 232.435C179.756 232.545 179.665 232.636 179.537 232.636H175.13C175.02 232.636 174.911 232.545 174.911 232.435Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 234.794C169.133 234.794 169.023 234.886 169.023 234.995C169.023 235.105 169.115 235.196 169.243 235.196H170.34C170.45 235.196 170.559 235.105 170.559 234.995C170.559 234.886 170.468 234.794 170.34 234.794H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.22 235.014C178.22 234.904 178.311 234.812 178.439 234.812H179.171C179.28 234.812 179.39 234.904 179.39 235.014C179.39 235.123 179.299 235.215 179.171 235.215H178.439C178.329 235.215 178.22 235.123 178.22 235.014Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 237.354C169.133 237.354 169.023 237.445 169.023 237.555C169.023 237.665 169.115 237.756 169.243 237.756H173.65C173.759 237.756 173.869 237.665 173.869 237.555C173.869 237.445 173.778 237.354 173.65 237.354H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 237.573C174.911 237.464 175.002 237.372 175.13 237.372H179.537C179.647 237.372 179.756 237.464 179.756 237.573C179.756 237.683 179.665 237.775 179.537 237.775H175.13C175.02 237.775 174.911 237.683 174.911 237.573Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 239.914C169.133 239.914 169.023 240.006 169.023 240.115C169.023 240.225 169.115 240.317 169.243 240.317H173.65C173.759 240.317 173.869 240.225 173.869 240.115C173.869 240.006 173.778 239.914 173.65 239.914H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 240.134C174.911 240.024 175.002 239.933 175.13 239.933H179.537C179.647 239.933 179.756 240.024 179.756 240.134C179.756 240.243 179.665 240.335 179.537 240.335H175.13C175.02 240.335 174.911 240.243 174.911 240.134Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 242.493C169.133 242.493 169.023 242.584 169.023 242.694C169.023 242.804 169.115 242.895 169.243 242.895H173.65C173.759 242.895 173.869 242.804 173.869 242.694C173.869 242.584 173.778 242.493 173.65 242.493H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 242.694C174.911 242.584 175.002 242.493 175.13 242.493H179.537C179.647 242.493 179.756 242.584 179.756 242.694C179.756 242.804 179.665 242.895 179.537 242.895H175.13C175.02 242.895 174.911 242.804 174.911 242.694Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.243 245.052C169.133 245.052 169.023 245.144 169.023 245.253C169.023 245.363 169.115 245.455 169.243 245.455H173.65C173.759 245.455 173.869 245.363 173.869 245.253C173.869 245.144 173.778 245.052 173.65 245.052H169.243Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.911 245.253C174.911 245.144 175.002 245.052 175.13 245.052H179.537C179.647 245.052 179.756 245.144 179.756 245.253C179.756 245.363 179.665 245.455 179.537 245.455H175.13C175.02 245.455 174.911 245.363 174.911 245.253Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.489 217.057C151.489 215.119 153.061 213.565 154.981 213.565C156.901 213.565 158.474 215.137 158.474 217.057C158.474 218.977 156.901 220.55 154.981 220.55C153.061 220.55 151.489 218.977 151.489 217.057Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74854 220.075C7.74854 214.571 12.2101 210.11 17.714 210.11C23.2178 210.11 27.6794 214.571 27.6794 220.075C27.6794 225.579 23.2178 230.04 17.714 230.04C12.2101 230.04 7.74854 225.579 7.74854 220.075Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.714 236.038C12.2101 236.038 7.74854 240.5 7.74854 246.003C7.74854 251.507 12.2101 255.969 17.714 255.969C23.2178 255.969 27.6794 251.507 27.6794 246.003C27.6794 240.5 23.2178 236.038 17.714 236.038Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5393 220.075C25.5393 224.39 22.0468 227.901 17.7133 227.901C13.3797 227.901 9.88721 224.408 9.88721 220.075C9.88721 215.741 13.3797 212.249 17.7133 212.249C22.0468 212.249 25.5393 215.741 25.5393 220.075Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7133 253.829C22.0286 253.829 25.5393 250.336 25.5393 246.003C25.5393 241.669 22.0468 238.177 17.7133 238.177C13.3797 238.177 9.88721 241.669 9.88721 246.003C9.88721 250.336 13.3797 253.829 17.7133 253.829Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.98 219.16C156.142 219.16 157.083 218.219 157.083 217.058C157.083 215.896 156.142 214.955 154.98 214.955C153.819 214.955 152.877 215.896 152.877 217.058C152.877 218.219 153.819 219.16 154.98 219.16Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1123 198.864C27.1123 200.802 25.5398 202.375 23.6016 202.375C21.6633 202.375 20.0908 200.802 20.0908 198.864C20.0908 196.926 21.6633 195.353 23.6016 195.353C25.5398 195.353 27.1123 196.926 27.1123 198.864Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6358 202.371C14.5736 202.304 16.0904 200.679 16.0238 198.742C15.9571 196.804 14.3322 195.287 12.3944 195.354C10.4566 195.42 8.93978 197.045 9.00643 198.983C9.07308 200.921 10.698 202.438 12.6358 202.371Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.485 193.872C9.72395 193.872 7.49316 196.103 7.49316 198.864C7.49316 201.625 9.72395 203.856 12.485 203.856H23.6024C26.3635 203.856 28.5942 201.625 28.5942 198.864C28.5942 196.103 26.3635 193.872 23.6024 193.872H12.485Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.584 188.313C25.5222 188.313 27.0947 186.741 27.0947 184.803C27.0947 182.865 25.5222 181.292 23.584 181.292C21.6458 181.292 20.0732 182.865 20.0732 184.803C20.0732 186.741 21.6458 188.313 23.584 188.313Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9956 184.803C15.9956 186.741 14.4231 188.313 12.4849 188.313C10.5466 188.313 8.97412 186.741 8.97412 184.803C8.97412 182.865 10.5466 181.292 12.4849 181.292C14.4231 181.292 15.9956 182.865 15.9956 184.803Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43701 184.803C7.43701 182.042 9.6678 179.811 12.4289 179.811H23.5462C26.3073 179.811 28.5381 182.042 28.5381 184.803C28.5381 187.564 26.3073 189.795 23.5462 189.795H12.4289C9.6678 189.795 7.43701 187.564 7.43701 184.803Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6658 166.682C15.6658 167.249 15.3001 167.724 14.8612 167.724H8.57115C8.1323 167.724 7.7666 167.267 7.7666 166.682V160.557C7.7666 159.99 8.1323 159.514 8.57115 159.514H14.8612C15.3001 159.514 15.6658 159.972 15.6658 160.557V166.682Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0077 168.127C28.0077 168.968 27.4774 169.663 26.8009 169.663H7.30887C6.65061 169.663 6.10205 168.986 6.10205 168.127V159.112C6.10205 158.271 6.63232 157.576 7.30887 157.576H26.7826C27.4408 157.576 27.9894 158.253 27.9894 159.112V168.127H28.0077Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.641 253.244C179.336 253.244 179.902 252.677 179.902 251.982V247.576H168.84V252.001C168.84 252.696 169.407 253.262 170.102 253.262H178.622L178.641 253.244Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.121 180.561C169.426 180.561 168.859 181.128 168.859 181.823V186.229H179.921V181.804C179.921 181.11 179.355 180.543 178.66 180.543H170.139L170.121 180.561Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.611 169.169C176.611 170.686 175.386 171.93 173.85 171.93C172.314 171.93 171.089 170.705 171.089 169.169C171.089 167.633 172.314 166.408 173.85 166.408C175.386 166.408 176.611 167.633 176.611 169.169Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.611 158.619C176.611 160.136 175.386 161.38 173.85 161.38C172.314 161.38 171.089 160.154 171.089 158.619C171.089 157.083 172.314 155.857 173.85 155.857C175.386 155.857 176.611 157.083 176.611 158.619Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.164 241.179C144.014 232.927 163.956 199.608 155.704 166.757C147.453 133.907 114.133 113.966 81.283 122.217C48.4327 130.469 28.4913 163.788 36.7428 196.638C44.9942 229.489 78.3138 249.43 111.164 241.179Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2125 127.058C66.0237 127.058 41.5581 151.524 41.5581 181.712C41.5581 211.901 66.0237 236.367 96.2125 236.367C126.401 236.367 150.867 211.901 150.867 181.712C150.867 151.524 126.401 127.058 96.2125 127.058ZM96.2125 227.59C70.8875 227.59 50.335 207.056 50.335 181.712C50.335 156.369 70.8692 135.835 96.2125 135.835C121.556 135.835 142.09 156.369 142.09 181.712C142.09 207.056 121.556 227.59 96.2125 227.59Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.393 187.54C124.627 173.632 115.974 159.735 102.066 156.501C88.1573 153.267 74.2607 161.92 71.0266 175.829C67.7926 189.737 76.4459 203.634 90.3543 206.868C104.263 210.102 118.159 201.448 121.393 187.54Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M181.768 177.781H167.012C166.628 177.781 166.317 178.092 166.317 178.476V255.256C166.317 255.639 166.628 255.95 167.012 255.95H181.768C182.152 255.95 182.463 255.639 182.463 255.256V178.476C182.463 178.092 182.152 177.781 181.768 177.781Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.424 130.898C11.424 132.415 10.1989 133.659 8.66292 133.659C7.12696 133.659 5.90186 132.434 5.90186 130.898C5.90186 129.362 7.12696 128.137 8.66292 128.137C10.1989 128.137 11.424 129.362 11.424 130.898Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 130.898H20.8952",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0075 130.898C28.0075 132.416 26.7824 133.659 25.2464 133.659C23.7105 133.659 22.4854 132.434 22.4854 130.898C22.4854 129.362 23.7105 128.137 25.2464 128.137C26.7824 128.137 28.0075 129.362 28.0075 130.898Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3477 130.898H37.4606",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9251 117.152C14.0474 114.944 12.3565 113.054 10.1482 112.932C7.94003 112.81 6.05077 114.501 5.92847 116.709C5.80617 118.917 7.49715 120.806 9.70536 120.929C11.9136 121.051 13.8028 119.36 13.9251 117.152Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5185 73.2026C19.6173 71.4179 18.2506 69.8909 16.4659 69.7921C14.6812 69.6933 13.1543 71.0599 13.0554 72.8446C12.9566 74.6294 14.3233 76.1563 16.108 76.2551C17.8927 76.354 19.4196 74.9873 19.5185 73.2026Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9576 36.9937C26.0213 35.8442 25.141 34.8608 23.9915 34.7971C22.8421 34.7335 21.8586 35.6137 21.795 36.7632C21.7313 37.9126 22.6115 38.8961 23.761 38.9598C24.9105 39.0234 25.8939 38.1432 25.9576 36.9937Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5276 37.0811C27.6393 35.0645 26.095 33.3392 24.0784 33.2275C22.0617 33.1158 20.3364 34.6601 20.2247 36.6767C20.113 38.6933 21.6573 40.4187 23.6739 40.5304C25.6905 40.642 27.4159 39.0978 27.5276 37.0811Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2105 120.932C27.423 120.932 29.215 119.14 29.215 116.928C29.215 114.715 27.423 112.923 25.2105 112.923C22.998 112.923 21.2061 114.715 21.2061 116.928C21.2061 119.14 22.998 120.932 25.2105 120.932Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0011 116.928C46.0011 119.14 44.2091 120.932 41.9966 120.932C39.7841 120.932 37.9922 119.14 37.9922 116.928C37.9922 114.715 39.7841 112.923 41.9966 112.923C44.2091 112.923 46.0011 114.715 46.0011 116.928Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 116.928H19.5425",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3462 102.483H27.4043",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7139 116.946H36.4737",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.967 94.5288C171.767 94.5288 169.17 97.1253 169.17 100.325C169.17 102.391 170.268 104.22 171.895 105.244L174.693 100.252C174.693 100.252 174.839 100.142 174.93 100.179C175.022 100.234 175.04 100.325 175.003 100.417L172.206 105.427C173.029 105.884 173.979 106.122 174.967 106.122C178.167 106.122 180.763 103.525 180.763 100.325C180.763 97.1253 178.167 94.5288 174.967 94.5288Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.317 46.0016V34.0595C182.317 33.6938 182.098 33.3464 181.75 33.2001C178.752 31.9018 175.424 31.1887 171.95 31.1887C168.475 31.1887 165.056 31.9384 162.002 33.2549",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M162.002 66.2421V78.7491C165.038 80.0839 168.402 80.8153 171.95 80.8153C175.497 80.8153 178.733 80.1022 181.75 78.804C182.098 78.6577 182.317 78.3286 182.317 77.9446V65.8032",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 56.4232C179.648 52.2992 176.49 48.7708 172.366 48.5424C168.242 48.314 164.714 51.472 164.485 55.596C164.257 59.7201 167.415 63.2484 171.539 63.4768C175.663 63.7052 179.191 60.5472 179.42 56.4232Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M177.777 56.3321C177.955 53.1155 175.492 50.3636 172.276 50.1855C169.059 50.0073 166.307 52.4704 166.129 55.687C165.951 58.9035 168.414 61.6554 171.631 61.8335C174.847 62.0117 177.599 59.5486 177.777 56.3321Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M171.948 31.1887V41.7393",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M171.948 70.2825V80.8147",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M156.663 9.6123H140.518C140.134 9.6123 139.823 9.92339 139.823 10.3071V14.275C139.823 14.6588 140.134 14.9699 140.518 14.9699H156.663C157.047 14.9699 157.358 14.6588 157.358 14.275V10.3071C157.358 9.92339 157.047 9.6123 156.663 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.507 9.6123H119.361C118.977 9.6123 118.666 9.92339 118.666 10.3071V14.275C118.666 14.6588 118.977 14.9699 119.361 14.9699H135.507C135.89 14.9699 136.202 14.6588 136.202 14.275V10.3071C136.202 9.92339 135.89 9.6123 135.507 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M114.369 9.6123H98.2236C97.8399 9.6123 97.5288 9.92339 97.5288 10.3071V14.275C97.5288 14.6588 97.8399 14.9699 98.2236 14.9699H114.369C114.753 14.9699 115.064 14.6588 115.064 14.275V10.3071C115.064 9.92339 114.753 9.6123 114.369 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2137 9.6123H77.0679C76.6841 9.6123 76.373 9.92339 76.373 10.3071V14.275C76.373 14.6588 76.6841 14.9699 77.0679 14.9699H93.2137C93.5974 14.9699 93.9085 14.6588 93.9085 14.275V10.3071C93.9085 9.92339 93.5974 9.6123 93.2137 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0765 9.6123H55.9307C55.5469 9.6123 55.2358 9.92339 55.2358 10.3071V14.275C55.2358 14.6588 55.5469 14.9699 55.9307 14.9699H72.0765C72.4602 14.9699 72.7713 14.6588 72.7713 14.275V10.3071C72.7713 9.92339 72.4602 9.6123 72.0765 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9202 9.6123H34.7744C34.3907 9.6123 34.0796 9.92339 34.0796 10.3071V14.275C34.0796 14.6588 34.3907 14.9699 34.7744 14.9699H50.9202C51.304 14.9699 51.6151 14.6588 51.6151 14.275V10.3071C51.6151 9.92339 51.304 9.6123 50.9202 9.6123Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M161.819 78.6026V92.9564C161.819 93.2124 161.618 93.4136 161.362 93.4136H30.6046C30.3486 93.4136 30.1475 93.2124 30.1475 92.9564V18.8284M161.819 18.8284V45.8904",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M161.819 18.8098V3.76106C161.819 2.22511 160.576 1 159.058 1H33.1279C31.4823 1 30.1475 2.33481 30.1475 3.98048V18.8098",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M151.269 24.1125H41.1738V89.0066H151.269V24.1125Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5203 88.8787L30.3115 93.3037",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1475 18.8096L41.4111 24.35",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M161.636 93.3037L150.61 88.7507",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M150.501 24.4597L161.82 18.8096",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M26.253 48.5415H6.45021C6.06646 48.5415 5.75537 48.8526 5.75537 49.2363V58.8543C5.75537 59.2381 6.06646 59.5492 6.45021 59.5492H26.253C26.6368 59.5492 26.9479 59.2381 26.9479 58.8543V49.2363C26.9479 48.8526 26.6368 48.5415 26.253 48.5415Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0922 24.1497H6.45021C6.06646 24.1497 5.75537 24.4608 5.75537 24.8445V34.4625C5.75537 34.8463 6.06646 35.1573 6.45021 35.1573H17.0922C17.4759 35.1573 17.787 34.8463 17.787 34.4625V24.8445C17.787 24.4608 17.4759 24.1497 17.0922 24.1497Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14.642 82.3689H6.45021C6.06646 82.3689 5.75537 82.68 5.75537 83.0637V86.2088C5.75537 86.5925 6.06646 86.9036 6.45021 86.9036H14.642C15.0257 86.9036 15.3368 86.5925 15.3368 86.2088V83.0637C15.3368 82.68 15.0257 82.3689 14.642 82.3689Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5126 99.4844H6.90724C6.52349 99.4844 6.2124 99.7955 6.2124 100.179V104.787C6.2124 105.171 6.52349 105.482 6.90724 105.482H17.5126C17.8964 105.482 18.2075 105.171 18.2075 104.787V100.179C18.2075 99.7955 17.8964 99.4844 17.5126 99.4844Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7459 98.8621H30.8423C30.4585 98.8621 30.1475 99.1732 30.1475 99.5569V105.372C30.1475 105.755 30.4585 106.066 30.8423 106.066H42.7459C43.1297 106.066 43.4408 105.755 43.4408 105.372V99.5569C43.4408 99.1732 43.1297 98.8621 42.7459 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2699 82.3689H18.0781C17.6944 82.3689 17.3833 82.68 17.3833 83.0637V86.2088C17.3833 86.5925 17.6944 86.9036 18.0781 86.9036H26.2699C26.6536 86.9036 26.9647 86.5925 26.9647 86.2088V83.0637C26.9647 82.68 26.6536 82.3689 26.2699 82.3689Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M185.864 127.661H163.885C163.501 127.661 163.19 127.972 163.19 128.356V144.959C163.19 145.343 163.501 145.654 163.885 145.654H185.864C186.247 145.654 186.558 145.343 186.558 144.959V128.356C186.558 127.972 186.247 127.661 185.864 127.661Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M185.864 112.028H163.885C163.501 112.028 163.19 112.339 163.19 112.722V118.738C163.19 119.122 163.501 119.433 163.885 119.433H185.864C186.247 119.433 186.558 119.122 186.558 118.738V112.722C186.558 112.339 186.247 112.028 185.864 112.028Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M171.93 129.819H165.566C165.183 129.819 164.872 130.13 164.872 130.514V135.798C164.872 136.182 165.183 136.493 165.566 136.493H171.93C172.313 136.493 172.624 136.182 172.624 135.798V130.514C172.624 130.13 172.313 129.819 171.93 129.819Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M184.199 129.819H177.836C177.452 129.819 177.141 130.13 177.141 130.514V135.798C177.141 136.182 177.452 136.493 177.836 136.493H184.199C184.583 136.493 184.894 136.182 184.894 135.798V130.514C184.894 130.13 184.583 129.819 184.199 129.819Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M181.072 139.346H168.693C168.31 139.346 167.999 139.657 167.999 140.041V142.326C167.999 142.71 168.31 143.021 168.693 143.021H181.072C181.456 143.021 181.767 142.71 181.767 142.326V140.041C181.767 139.657 181.456 139.346 181.072 139.346Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.22 127.204V131.135C149.22 131.227 149.147 131.3 149.056 131.3C148.964 131.3 148.891 131.227 148.891 131.135V127.204C146.752 127.296 145.051 129.051 145.051 131.209C145.051 133.366 146.843 135.213 149.056 135.213C151.268 135.213 153.06 133.421 153.06 131.209C153.06 128.996 151.36 127.296 149.22 127.204Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.305 115.63C151.305 114.112 152.53 112.869 154.066 112.869C155.602 112.869 156.827 114.094 156.827 115.63C156.827 117.166 155.602 118.391 154.066 118.391C152.53 118.391 151.305 117.166 151.305 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.06 115.63C140.06 114.112 141.285 112.869 142.821 112.869C144.357 112.869 145.582 114.094 145.582 115.63C145.582 117.166 144.357 118.391 142.821 118.391C141.285 118.391 140.06 117.166 140.06 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.814 115.63C128.814 114.112 130.039 112.869 131.575 112.869C133.111 112.869 134.336 114.094 134.336 115.63C134.336 117.166 133.111 118.391 131.575 118.391C130.039 118.391 128.814 117.166 128.814 115.63Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M171.072 93.5598L171.456 94.2181",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M178.495 106.414L178.879 107.073",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M168.218 96.4124L168.876 96.7963",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.072 103.836L181.731 104.22",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M167.157 100.307H167.925",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M182.005 100.307H182.773",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.218 104.22L168.876 103.836",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M181.072 96.7963L181.731 96.4124",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M171.072 107.073L171.437 106.414",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M178.495 94.2181L178.879 93.5598",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.057 125.595V126.235",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M146.897 126.016L147.117 126.546",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M145.089 127.241L145.472 127.624",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M152.62 134.774L153.699 135.853",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 129.051L144.394 129.271",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 133.128L154.231 133.348",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M143.442 131.209H144.009",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M154.084 131.209H154.651",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 133.348L144.394 133.128",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 129.271L154.231 129.051",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M144.412 135.835L145.472 134.774",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M152.62 127.624L153.003 127.241",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M150.976 126.546L151.195 126.016",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M186.211 56.7993C186.647 48.9244 180.617 42.1869 172.742 41.7507C164.867 41.3146 158.129 47.3449 157.693 55.2199C157.257 63.0949 163.287 69.8323 171.162 70.2685C179.037 70.7046 185.775 64.6743 186.211 56.7993Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0552 157.576V169.827",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9868 140.735V148.123",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M174.855 112.192V119.415",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2139 104.348H41.3747",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4779 98.8621H47.5742C47.1905 98.8621 46.8794 99.1732 46.8794 99.5569V105.372C46.8794 105.755 47.1905 106.066 47.5742 106.066H59.4779C59.8616 106.066 60.1727 105.755 60.1727 105.372V99.5569C60.1727 99.1732 59.8616 98.8621 59.4779 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9258 104.348H58.1049",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1893 98.8621H64.2857C63.9019 98.8621 63.5908 99.1732 63.5908 99.5569V105.372C63.5908 105.755 63.9019 106.066 64.2857 106.066H76.1893C76.573 106.066 76.8841 105.755 76.8841 105.372V99.5569C76.8841 99.1732 76.573 98.8621 76.1893 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6562 104.348H74.8354",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9212 98.8621H81.0176C80.6338 98.8621 80.3228 99.1732 80.3228 99.5569V105.372C80.3228 105.755 80.6338 106.066 81.0176 106.066H92.9212C93.305 106.066 93.6161 105.755 93.6161 105.372V99.5569C93.6161 99.1732 93.305 98.8621 92.9212 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3882 104.348H91.5491",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M109.651 98.8621H97.7476C97.3638 98.8621 97.0527 99.1732 97.0527 99.5569V105.372C97.0527 105.755 97.3638 106.066 97.7476 106.066H109.651C110.035 106.066 110.346 105.755 110.346 105.372V99.5569C110.346 99.1732 110.035 98.8621 109.651 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1006 104.348H108.28",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M126.362 98.8621H114.459C114.075 98.8621 113.764 99.1732 113.764 99.5569V105.372C113.764 105.755 114.075 106.066 114.459 106.066H126.362C126.746 106.066 127.057 105.755 127.057 105.372V99.5569C127.057 99.1732 126.746 98.8621 126.362 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M115.833 104.348H125.012",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M143.094 98.8621H131.19C130.807 98.8621 130.496 99.1732 130.496 99.5569V105.372C130.496 105.755 130.807 106.066 131.19 106.066H143.094C143.478 106.066 143.789 105.755 143.789 105.372V99.5569C143.789 99.1732 143.478 98.8621 143.094 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M132.562 104.348H141.741",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.827 98.8621H147.923C147.539 98.8621 147.228 99.1732 147.228 99.5569V105.372C147.228 105.755 147.539 106.066 147.923 106.066H159.827C160.21 106.066 160.521 105.755 160.521 105.372V99.5569C160.521 99.1732 160.21 98.8621 159.827 98.8621Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M149.293 104.348H158.454",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4669 145.032L26.4726 144.538L25.4669 144.044L24.4795 143.551V144.538V145.526L25.4669 145.032Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35693 144.538L10.3626 145.032L11.3683 145.526V144.538V143.551L10.3626 144.044L9.35693 144.538Z",
    fill: "#FCFCFC",
    fillOpacity: 0.6
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8243 140.735H6.66909C6.43683 140.735 6.24854 140.924 6.24854 141.156V147.72C6.24854 147.953 6.43683 148.141 6.66909 148.141H14.8243C15.0565 148.141 15.2448 147.953 15.2448 147.72V141.156C15.2448 140.924 15.0565 140.735 14.8243 140.735Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3052 140.735H21.1501C20.9178 140.735 20.7295 140.924 20.7295 141.156V147.72C20.7295 147.953 20.9178 148.141 21.1501 148.141H29.3052C29.5375 148.141 29.7258 147.953 29.7258 147.72V141.156C29.7258 140.924 29.5375 140.735 29.3052 140.735Z",
    stroke: "#FCFCFC",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjBooth);
export default __webpack_public_path__ + "static/media/dj-booth.c2e5a98f297b83c8197b8080ebca914e.svg";
export { ForwardRef as ReactComponent };